import { statsData } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-18 bg-primary-500">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {statsData.map((stat) => (
            <div key={stat.id} className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-primary-100 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}